// Show the Back to Top button when scrolling down
window.addEventListener('scroll', function() {
    const backToTopButton = document.getElementById('back-to-top');
    if (window.scrollY > 300) {
        backToTopButton.style.display = 'block';
    } else {
        backToTopButton.style.display = 'none';
    }
});
 
// Smooth scroll to the top when the button is clicked
document.getElementById('back-to-top').addEventListener('click', function(e) {
    e.preventDefault();
    window.scrollTo({
        top: 0,
        behavior: 'smooth'
    });
});

// document.addEventListener("DOMContentLoaded", function () {

//   const headerRow = document.querySelector(".header__row");

//   if (
//     document.body.classList.contains("index") ||
//     document.body.classList.contains("page") ||
//     document.body.classList.contains("product") ||
//     document.body.classList.contains("collection")
//   ) {

//     window.addEventListener("scroll", function () {

//       if (window.scrollY > 50) {
//         headerRow.classList.add("header-scrolled");
//       } else {
//         headerRow.classList.remove("header-scrolled");
//       }

//     });

//   }

// });

document.addEventListener("DOMContentLoaded", function () {

  const headerRow = document.querySelector(".cn-header");

  function handleScroll() {
    if (window.scrollY > 0) {
      headerRow.classList.add("header-scrolled");
    } else {
      headerRow.classList.remove("header-scrolled");
    }
  }

  requestAnimationFrame(handleScroll);
  window.addEventListener("scroll", handleScroll, { passive: true });

});

document.addEventListener('click', function(e) {
    const btn = e.target.closest('#refer-btn');
    if (btn) {
      e.preventDefault();
      if (window.StampedFn) {
        StampedFn.toggleLauncher();
      }
    }
  });